/** Signing in, passwords, two-factor sign-in and the sessions of an account — English, the source of the other languages */
const auth = {
  "auth.tagline": "Network Management Platform",
  "auth.ssoCouldNotStart": "Single sign-on could not start",
  "auth.loginFailed": "Login failed",
  "auth.idleSignedOut": "You were signed out after a time without activity. Sign in again to continue.",
  "auth.emailPlaceholder": "you@company.com",
  "auth.signIn": "Sign in",
  "auth.signInSso": "Sign in with single sign-on",
  "auth.ssoByEmailHint": "Your work address tells which company's sign-in to use.",
  "auth.continueSso": "Continue with single sign-on",
  "auth.forgotPassword": "Forgot password?",
  "auth.resetFailed": "Failed to send reset email",
  "auth.setFailed": "Failed to set password",
  "auth.resetTitle": "Reset password",
  "auth.setTitle": "Set your password",
  "auth.resetSubtitle": "Enter your email to receive a reset link",
  "auth.setSubtitle": "Create a secure password for your account",
  "auth.checkEmail": "Check your email",
  "auth.passwordSet": "Password set successfully",
  "auth.resetSent": "If that email exists, a reset link has been sent.",
  "auth.accountActive": "Your account is now active. You can sign in.",
  "auth.goToLogin": "Go to login",
  "auth.sendResetLink": "Send reset link",
  "auth.backToLogin": "Back to login",
  "auth.newPassword": "New password",
  "auth.confirmPassword": "Confirm password",
  "auth.check.length": "At least 12 characters",
  "auth.check.upper": "Uppercase letter",
  "auth.check.lower": "Lowercase letter",
  "auth.check.number": "Number",
  "auth.check.match": "Passwords match",
  "auth.setAndActivate": "Set password & activate account",
  "auth.landing.title": "Where do you want to go?",
  "auth.landing.signedInAs": "Signed in as {email}",
  "auth.landing.noAccess": "You do not have access to a company yet. Ask an administrator to add you.",
  "auth.landing.platform": "Platform administration",
  "auth.landing.platformSub": "Companies, licences, edge proxy and settings",
  "auth.landing.companyAdmin": "Company admin",
  "auth.landing.member": "Member",
  "auth.ssoIncomplete": "The sign-in could not be completed. Sign in again.",
  "auth.backToSignIn": "Back to sign-in",
  "auth.signingIn": "Signing you in…",
  "auth.reauth.title": "Confirm it is you",
  "auth.reauth.sso": "This change needs you to sign in at your identity provider again (at most every 10 minutes). Afterwards, make the change once more.",
  "auth.reauth.idpUnreachable": "Could not reach the identity provider",
  "auth.reauth.password": "This change needs your password again. You will not be asked again for the next 10 minutes.",
  "auth.tf.startAgain": "← Start again",
  "auth.tf.setupTitle": "Set up two-factor sign-in",
  "auth.tf.setupIntro": "Your account needs a code from an authenticator app at every sign-in. Set it up once, now.",
  "auth.tf.title": "Two-factor sign-in",
  "auth.tf.enterRecovery": "Enter one of your recovery codes. Each one works once.",
  "auth.tf.enterCode": "Enter the 6-digit code your authenticator app shows now.",
  "auth.tf.recoveryCode": "Recovery code",
  "auth.tf.code": "Code",
  "auth.tf.verify": "Verify",
  "auth.tf.useApp": "Use a code from the app",
  "auth.tf.lostPhone": "Lost your phone? Use a recovery code",
  "auth.tf.couldNotStart": "Could not start the setup",
  "auth.tf.savedContinue": "I've saved them — continue",
  "auth.tf.saved": "I've saved them",
  "auth.tf.step1": "Open an authenticator app on your phone (Google Authenticator, Microsoft Authenticator, 1Password, …).",
  "auth.tf.step2": "Scan the QR code, or type the key.",
  "auth.tf.step3": "Enter the 6-digit code the app shows.",
  "auth.tf.qrAlt": "QR code with the key, to scan with your authenticator app",
  "auth.tf.key": "Key",
  "auth.tf.codeFromApp": "Code from the app",
  "auth.tf.turnOn": "Turn on",
  "auth.tf.saveCodes": "Save these recovery codes somewhere safe, such as a password manager. Each one signs you in once if you lose your phone. They are shown only now.",
  "auth.tf.recoveryCodes": "Recovery codes",
  "auth.tf.codesCopied": "Recovery codes copied",
  "auth.tf.copyHint": "Select the codes and copy them, or download them.",
  "auth.prot.ssoLinked": "Single sign-on linked",
  "auth.prot.ssoLinkedText": "You can now sign in with your identity provider.",
  "auth.prot.couldNotStart": "Could not start",
  "auth.prot.title": "Sign-in protection",
  "auth.prot.idleLabel": "Sign me out after a time without activity",
  "auth.prot.afterMax": "After {duration} (the longest allowed here)",
  "auth.prot.after": "After {duration}",
  "auth.prot.never": "Never",
  "auth.prot.staySignedIn": "You stay signed in while you do not use the dashboard, until the session reaches its maximum length.",
  "auth.prot.signedOutAfter": "A session you leave open is signed out {duration} after you last used it.",
  "auth.prot.newDeviceMail": "Email me when my account signs in from a device it has not used before",
  "auth.prot.sso": "Single sign-on",
  "auth.prot.linked": "Linked",
  "auth.prot.linkedText": "You can sign in with your company's identity provider.",
  "auth.prot.linkText": "Your company signs in through its identity provider. Link your account to use it.",
  "auth.prot.linkMine": "Link my account",
  "auth.sec.isOff": "Two-factor sign-in is off",
  "auth.sec.isOn": "Two-factor sign-in is on",
  "auth.sec.signedOutDevice": "Signed out on that device",
  "auth.sec.signedOutOthers": { one: "Signed out on {count} other device", other: "Signed out on {count} other devices" },
  "auth.sec.couldNotSignOut": "Could not sign out",
  "auth.sec.newSetNote": "A new set replaces the old one: the old codes stop working.",
  "auth.sec.offNote": "Signing in will need only your password again.",
  "auth.sec.codeFromYourApp": "Code from your authenticator app",
  "auth.sec.newCodes": "New recovery codes",
  "auth.sec.turnOff": "Turn off",
  "auth.sec.on": "On",
  "auth.sec.since": { one: "since {date} · {count} recovery code left", other: "since {date} · {count} recovery codes left" },
  "auth.sec.required": " · required for your account",
  "auth.sec.offText": "Off. With two-factor sign-in, a stolen password is not enough: signing in also needs a code from an app on your phone.",
  "auth.sec.whereSignedIn": "Where you're signed in",
  "auth.sec.thisDevice": "This device",
  "auth.sec.signedInWhen": "signed in {when}",
  "auth.sec.activeWhen": "active {when}",
  "auth.sec.endsDate": "ends {date}",
  "auth.sec.signOutDevice": "Sign out {device}, signed in {when}",
  "auth.sec.confirmSignOutAll": "Sign out on every other device?",
  "auth.sec.signOutOthers": "Sign out other devices",
  "auth.landing.client": "Events of {customer}",
  "auth.landing.clientOpens": "Events of {customer} — opens {when}",
  "auth.landing.clientNoEvent": "Events of {customer} — opens with the next event",
  "auth.clientWindowClosed": "Your sign-in is open only during your event",
  "auth.app.stayPrompt": "Stay signed in on this phone",
  "auth.app.unlockReason": "Unlock Velanox",
  "auth.app.unlock": "Unlock",
  "auth.app.changeServer": "Change server",
  "auth.app.offline": "You are offline",
}

export default auth
